import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-[var(--radius-pill)] border px-3 py-1 text-[12px] font-medium leading-none transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--color-burgundy-500)] focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-[var(--color-burgundy-100)] text-[var(--color-burgundy-900)]",
        secondary:
          "border-transparent bg-[rgba(63,107,78,0.12)] text-[#2F5239]",
        destructive:
          "border-transparent bg-[rgba(163,50,50,0.12)] text-[var(--color-danger)]",
        outline: "border-[var(--color-mist-300)] bg-transparent text-[var(--color-charcoal)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
